module.exports = __webpack_public_path__ + "static/other/campus.18330ec6.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/university_map/campus.json
// module id = 2301
// module chunks = 0